import { TopicJob } from '@doda/pc/src/pages/DodaFront/View/FeaturedJobList/types';

/**
 * GetPublishingPeriod インターフェースは公開期間
 */
interface GetPublishingPeriod {
  /** 公開スケジュールの開始日 */
  startDate: TopicJob['publishingSchedulePeriodStartDate'];
  /** 公開スケジュールの終了日 */
  endDate: TopicJob['publishingSchedulePeriodEndDate'];
}

/**
 * 公開期間のテキストを取得する関数
 *
 * @param {GetPublishingPeriod} param0 - 公開期間のオブジェクト（開始日と終了日）
 * @returns {string} 公開期間を表すテキストを返す
 */
export const getPublishingPeriod = ({
  startDate,
  endDate,
}: GetPublishingPeriod) => {
  if (!startDate) return '';

  const publishingPeriodText = `[掲載期間] ${startDate.replace(/-/g, '.')}～${
    endDate?.replace(/-/g, '.') ?? ''
  }`;

  return publishingPeriodText;
};
